import { FullLoadingSpinner } from '@capitalise/ui-design-system';
import PropTypes from 'prop-types';
import { lazy, Suspense } from 'react';

import LoggedNavbar from '../../../LoggedNavbar';
const TeamWizzard = lazy(() => import('../../../TeamWizzard'));
const MonitorWizzard = lazy(() => import('../../../MonitorWizzard'));
const ResponsesReportWizzard = lazy(() => import('../../../ResponsesReportWizzard'));

export default function BaseLayout({ children, grey }) {
  return (
    <section className={`p-dashboard-pg${grey ? ' p-dashboard-pg--grey' : ''}`}>
      <LoggedNavbar />
      {children}
      <Suspense fallback={<FullLoadingSpinner />}>
        <TeamWizzard />
      </Suspense>
      <Suspense fallback={<FullLoadingSpinner />}>
        <MonitorWizzard />
      </Suspense>
      <Suspense fallback={<FullLoadingSpinner />}>
        <ResponsesReportWizzard />
      </Suspense>
    </section>
  );
}

BaseLayout.defaultProps = {
  grey: false,
};

BaseLayout.propTypes = {
  children: PropTypes.node.isRequired,
  grey: PropTypes.bool,
};
